import * as types from 'actionTypes/ngwords';
import * as utils from 'misc/utils';

// Create ======================================================================
const create = utils.createCreateAction(types.CREATE);
export const createRequest = create.requestFn;
export const createSuccess = create.successFn;
export const createFailure = create.failureFn;

// List ========================================================================
const list = utils.createSearchAction(types.LIST);
export const listRequest = list.requestFn;
export const listSuccess = list.successFn;
export const listFailure = list.failureFn;

// Batch Delete ================================================================
export const batchDeleteRequest = (values) => ({
  type: types.BATCH_DELETE.REQUEST,
  payload: { values }
});
export const batchDeleteSuccess = (values) => ({
  type: types.BATCH_DELETE.SUCCESS,
  payload: { values }
});

export const batchDeleteFailure = (error) => ({
  type: types.BATCH_DELETE.FAILURE,
  payload: { error }
});